import { __assign, __rest, __extends } from 'tslib';
import { removeVNodeDom, createVNode, createComponentVNode, mount, findDomsFromVNode, patch as patch$1, findDomFromVNode, unmount as unmount$1, Component as Component$1, callAll } from 'intact';
export * from 'intact';
import { createApp, h, KeepAlive, getCurrentInstance, cloneVNode, Comment, Text, Fragment, isVNode, camelize, vShow, isRef, createVNode as createVNode$1 } from 'vue';
import { isInvalid, isStringOrNumber, hasOwn, isArray, isFunction, isString, EMPTY_OBJ, proxyFragment, isFragmentDom, proxyFragmentParent } from 'intact-shared';

// we must use this hack method to get patch function
var internals;
createApp({
    render: function () {
        return h(KeepAlive, null, h(function () {
            var instance = getCurrentInstance();
            internals = instance.parent.ctx.renderer;
        }));
    }
}).mount(document.createElement('div'));
var _a$1 = internals, patch = _a$1.p, unmount = _a$1.um;
var Wrapper = /*#__PURE__*/ /*#__PURE__*/ /** @class */ (function () {
    function Wrapper($props, $vNode, $SVG, $mountedQueue, $senior) {
        this.$props = $props;
        this.$vNode = $vNode;
        this.$SVG = $SVG;
        this.$mountedQueue = $mountedQueue;
        this.$senior = $senior;
        this.$inited = true;
        this.$lastInput = createVNode('div');
    }
    Wrapper.prototype.$init = function (props) { };
    Wrapper.prototype.$render = function (lastVNode, vNode, parentDom, anchor) {
        if (lastVNode) {
            removeVNodeDom(lastVNode, parentDom);
        }
        else if (!parentDom) {
            parentDom = document.createDocumentFragment();
        }
        var vnode = getVueVNode(vNode);
        patch(null, vnode, parentDom, anchor, getParent(this), null, this.$SVG);
        // add dom to the $lastInput for findDomFromVNode
        this.$lastInput.dom = vnode.el;
    };
    Wrapper.prototype.$update = function (lastVNode, vNode, parentDom, anchor) {
        var lastVnode = lastVNode.props.vnode;
        var nextVnode = getVueVNode(vNode);
        patch(lastVnode, nextVnode, parentDom, anchor, getParent(this), null, this.$SVG);
        this.$lastInput.dom = nextVnode.el;
    };
    Wrapper.prototype.$unmount = function (vNode, nextVNode) {
        unmount(vNode.props.vnode, getParent(this), null, !!nextVNode);
    };
    return Wrapper;
}());
function getParent(instance) {
    var senior = instance.$senior;
    var $senior = senior;
    do {
        var vueInstance = $senior.vueInstance;
        if (vueInstance) {
            vueInstance.fakeInstance = senior;
            return vueInstance;
        }
    } while ($senior = $senior.$senior);
    // should not hit this
    /* istanbul ignore next */
    return null;
}
function getVueVNode(vNode) {
    var props = vNode.props;
    var vnode = props.vnode;
    // if we are reusing the vNode, clone it
    var hasCloned = false;
    if (vnode.el) {
        vnode = cloneVNode(vnode);
        hasCloned = true;
    }
    var shouldAssign = true;
    for (var key in props) {
        if (key === 'vnode')
            continue;
        // clone the vnode at first
        if (!hasCloned) {
            vnode = cloneVNode(vnode);
            hasCloned = true;
        }
        var _props = vnode.props;
        if (shouldAssign) {
            // props may be a EMPTY_OBJ, but we can not get its reference,
            // so we use a flag to handle it
            _props = vnode.props = __assign({}, _props);
            shouldAssign = false;
            // should change patchFlag to let Vue full diff props
            vnode.patchFlag |= 16;
        }
        var value = props[key];
        // is event
        if (key === 'className') {
            _props.class = value;
            // } else if (key === 'style') {
            // _props.style = {..._props.style, ...value};
        }
        else if (key.substr(0, 3) === 'ev-') {
            var name_1 = key.substr(3);
            _props["on" + name_1[0].toUpperCase() + name_1.substr(1)] = value;
        }
        else {
            _props[key] = value;
        }
    }
    vNode.props = __assign(__assign({}, props), { vnode: vnode });
    return vnode;
}

var cid = 'IntactVueFunctional';
function functionalWrapper(Component) {
    function Ctor(props, context) {
        if (context) {
            // invoked by Vue
            var forwardRef = props.forwardRef, rest = __rest(props, ["forwardRef"]);
            var _props = normalizeProps({
                props: rest,
                children: context.slots,
                type: {
                    Component: Component,
                },
                // ref: forwardRef,
            });
            if (forwardRef) {
                _props.ref = forwardRef;
            }
            // functional component of intact must return VNodeComponentClass
            var vNode = Component(_props, true /* is in vue */);
            if (Array.isArray(vNode)) {
                return vNode.map(function (vNode) { return toVueVNode(vNode); });
            }
            return toVueVNode(vNode);
        }
        else {
            // invoked by Intact
            return Component(props);
        }
    }
    Ctor.displayName = Component.displayName || Component.name;
    Ctor.$cid = cid;
    return Ctor;
}
function toVueVNode(vNode) {
    // if (isStringOrNumber(vNode)) return vNode;
    if (vNode) {
        var props = vNode.props;
        var ref = vNode.ref;
        var vnode = h(vNode.tag, 
        // because Vue will normalize some styles, but the props of vNode in Intact
        // is immutable, we must clone it here.
        props ? (ref ? __assign(__assign({}, props), { ref: ref }) : __assign({}, props)) : null);
        vNode.ref = null;
        return vnode;
    }
}

function beforeInsert(vNode, parent) {
    var dom = vNode.dom;
    var i;
    while (parent) {
        // find Intact Component which renders by Vue
        if (i = parent.vueInstance) {
            var vnode = i.vnode;
            setScopeId(dom, vnode, vnode.scopeId, vnode.slotScopeIds, i.parent, false);
            break;
        }
        parent = parent.$senior;
    }
}
function setScopeId(el, vnode, scopeId, slotScopeIds, parentComponent, shouldFindParent) {
    if (el.nodeType !== 1)
        return;
    if (scopeId) {
        hostSetScopeId(el, scopeId);
    }
    /* istanbul ignore next */
    if (slotScopeIds) {
        for (var i = 0; i < slotScopeIds.length; i++) {
            hostSetScopeId(el, slotScopeIds[i]);
        }
    }
    if (parentComponent && shouldFindParent) {
        var subTree = parentComponent.subTree;
        if (vnode === subTree) {
            var parentVNode = parentComponent.vnode;
            setScopeId(el, parentVNode, parentVNode.scopeId, 
            // slotScopeIds is @internal
            parentVNode.slotScopeIds, parentComponent.parent, shouldFindParent);
        }
    }
}
function hostSetScopeId(el, scopeId) {
    el.setAttribute(scopeId, '');
}

function normalize(vnode, normalizeRef) {
    if (isInvalid(vnode))
        return null;
    if (isStringOrNumber(vnode) || isIntactVNode(vnode))
        return vnode;
    var type = vnode.type;
    var vNode;
    if (isIntactComponent(vnode)) {
        var props = normalizeProps(vnode);
        vNode = createComponentVNode(4 /* ComponentUnknown */, getIntactComponent(vnode), props, vnode.key, normalizeRef ? getNormalizedRef(vnode.ref) : null);
        // use to add scopeId
        if (normalizeRef) {
            vNode.hooks = {
                beforeInsert: beforeInsert,
            };
        }
    }
    else {
        // ignore comment vNode
        if (type === Comment)
            return null;
        if (type === Text)
            return vnode.children;
        // spread fragment
        if (type === Fragment) {
            return normalizeChildren(vnode.children, normalizeRef);
        }
        vNode = createComponentVNode(8 /* ComponentClass */, Wrapper, { vnode: vnode }, vnode.key);
    }
    // tell Vue that this is a read only object, and don't make it reactive
    vNode.__v_isReadonly = true;
    return vNode;
}
function isIntactComponent(vnode) {
    return !!vnode.type.Component || vnode.type.$cid === cid;
}
function getIntactComponent(vnode) {
    var type = vnode.type;
    if (type.$cid === cid)
        return type;
    return type.Component;
}
function isIntactVNode(vNode) {
    return 'childrenType' in vNode;
}
function normalizeChildren(vNodes, normalizeRef) {
    if (normalizeRef === void 0) { normalizeRef = true; }
    var loop = function (vNodes) {
        if (Array.isArray(vNodes)) {
            var ret_1 = [];
            vNodes.forEach(function (vNode) {
                if (Array.isArray(vNode)) {
                    ret_1.push.apply(ret_1, loop(vNode));
                }
                else if (isVNode(vNode)) {
                    var results = normalize(vNode, normalizeRef);
                    if (Array.isArray(results)) {
                        ret_1.push.apply(ret_1, results);
                    }
                    else {
                        ret_1.push(results);
                    }
                }
                else if (isStringOrNumber(vNode)) {
                    ret_1.push(vNode);
                }
            });
            return ret_1;
        }
        return normalize(vNodes, normalizeRef);
    };
    var ret = loop(vNodes);
    if (Array.isArray(ret)) {
        var l = ret.length;
        return l === 0 ? undefined : l === 1 ? ret[0] : ret;
    }
    return ret;
}
function normalizeProps(vnode) {
    var attrs = vnode.props;
    var slots = vnode.children;
    var Component = getIntactComponent(vnode);
    var props = {};
    var propTypes = Component.typeDefs;
    for (var key in attrs) {
        var value = attrs[key];
        switch (key) {
            case 'ref': break;
            case 'class':
                props.className = value;
                break;
            case 'modelValue':
                props.value = value;
                break;
            default:
                if (isOn(key)) {
                    normalizeEvents(props, key, value);
                    break;
                }
                if (propTypes) {
                    var camelizedKey = camelize(key);
                    if (hasOwn.call(propTypes, camelizedKey)) {
                        value = normalizeBoolean(propTypes, key, camelizedKey, value);
                        key = camelizedKey;
                    }
                }
                props[key] = value;
                break;
        }
    }
    normalizeSlots(slots, props);
    normalizeDirs(vnode.dirs, props);
    // add scopeId
    // const scopeId = vnode.scopeId;
    // if (scopeId) {
    // props[scopeId] = '';
    // }
    // normalizeRef(vnode.ref, props);
    return props;
}
var onRE = /^on[^a-z]/;
var isOn = function (key) { return onRE.test(key); };
function normalizeEvents(props, key, value) {
    var name;
    var cb = value;
    var _isArray = isArray(value);
    var changeCallback = function (propName) { return function (v) {
        var modifiersKey = "".concat(propName === 'value' ? 'model' : propName, "Modifiers");
        var _a = props[modifiersKey] || EMPTY_OBJ, number = _a.number, trim = _a.trim;
        if (trim) {
            v = String(v).trim();
        }
        else if (number) {
            v = Number(v);
        }
        if (_isArray) {
            value.forEach(function (value) { return value(v); });
        }
        else {
            value(v);
        }
    }; };
    if (key.startsWith('onUpdate:')) {
        var propName = camelize(key.substr(9));
        if (propName === 'modelValue')
            propName = 'value';
        name = "$model:".concat(propName);
        cb = changeCallback(propName);
    }
    else {
        key = key.substring(2);
        if (key.startsWith('Change:')) {
            // onChange:name -> ev-$change:name
            name = "$change:".concat(key.substring(7));
        }
        else {
            // onClick -> ev-click
            // onChange -> ev-change
            if (key === 'Change') {
                name = 'change';
            }
            else if (key.startsWith('Change')) {
                // e.g. onChangeValue -> ev-$change:value
                // e.g. onChangePropName -> ev-$change:propName
                name = "$change:".concat(key[6].toLowerCase() + key.substring(7));
            }
            else {
                name = key[0].toLowerCase() + key.substring(1);
            }
        }
        if (_isArray) {
            cb = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                value.forEach(function (value) { return value.apply(void 0, args); });
            };
        }
    }
    props["ev-".concat(name)] = cb;
}
function normalizeBoolean(propTypes, key, camelizedKey, value) {
    var tmp;
    if ((
    // value is Boolean
    (tmp = propTypes[camelizedKey]) === Boolean ||
        tmp && (
        // value contains Boolean
        isArray(tmp) && tmp.indexOf(Boolean) > -1 ||
            (tmp = tmp.type) && (
            // value.type is Boolean
            tmp === Boolean ||
                // value.type contains Boolean
                isArray(tmp) && tmp.indexOf(Boolean) > -1))) &&
        (value === '' || value === key)) {
        value = true;
    }
    return value;
}
function normalizeSlots(slots, props) {
    if (!slots)
        return;
    // is array children
    if (isArray(slots)) {
        return props.children = normalizeChildren(slots);
    }
    // is string
    if (isStringOrNumber(slots)) {
        return props.children = slots;
    }
    // the default slot maybe a scope slot, but we can not detect
    // whether it is or not, so we try to normalize it as children and
    // then treat it as a default scope slot too.
    if (slots.default) {
        var slot = slots.default;
        try {
            // Vue will detect whether the slot is invoked outside or not,
            // but it does not affetch anything in here,
            // so we keep the warning silent
            //
            // Vue will warn if we get property of undefined, we keep it silent
            // silentWarn();
            var validSlotContent = ensureValidVNode(slot());
            props.children = validSlotContent ? normalizeChildren(validSlotContent) : null;
            // resetWarn();
        }
        catch (e) { }
    }
    var blocks = null;
    var _loop_1 = function (key) {
        if (isInternalKey(key))
            return "continue";
        var slot = slots[key];
        if (!blocks)
            blocks = {};
        blocks[key] = function (parent, data) {
            // if the content is invalid, use parent instead
            // this is the default behavior of Vue
            var validSlotContent = ensureValidVNode(slot(data));
            return validSlotContent ? normalizeChildren(validSlotContent) : parent();
        };
    };
    for (var key in slots) {
        _loop_1(key);
    }
    if (blocks) {
        props.$blocks = blocks;
    }
}
function ensureValidVNode(vnodes) {
    if (!isArray(vnodes))
        vnodes = [vnodes];
    return vnodes.some(function (child) {
        if (!isVNode(child)) {
            return true;
        }
        if (child.type === Comment) {
            return false;
        }
        if (child.type === Fragment && !ensureValidVNode(child.children)) {
            return false;
        }
        return true;
    }) ? vnodes : null;
}
var isInternalKey = function (key) { return key[0] === '_' || key === '$stable'; };
function normalizeDirs(dirs, props) {
    if (!dirs)
        return;
    dirs.find(function (_a) {
        var dir = _a.dir, value = _a.value;
        // only handle v-show
        if (dir === vShow) {
            if (!value) {
                (props.style || (props.style = {})).display = 'none';
            }
            return true;
        }
    });
}
function getNormalizedRef(rawRef) {
    if (isFunction(rawRef))
        return rawRef;
    else if (rawRef) {
        return function (i) {
            setRef(rawRef, i);
        };
    }
    return null;
}
function setRef(rawRef, value) {
    if (isArray(rawRef)) {
        rawRef.forEach(function (r, i) { return setRef(r, value); });
        return;
    }
    var owner = rawRef.i, ref = rawRef.r;
    var refs = !Object.keys(owner.refs).length ? (owner.refs = {}) : owner.refs;
    if (isString(ref)) {
        refs[ref] = value;
        var setupState = owner.setupState;
        if (hasOwn.call(setupState, ref)) {
            setupState[ref] = value;
        }
    }
    else if (isRef(ref)) {
        ref.value = value;
    }
    else if (isFunction(ref)) {
        ref(value, refs);
    }
    else {
        console.warn('Invalid template ref type:', value, "(".concat(typeof value, ")"));
    }
}

var StackPhase;
(function (StackPhase) {
    StackPhase[StackPhase["Mount"] = 0] = "Mount";
    StackPhase[StackPhase["Update"] = 1] = "Update";
})(StackPhase || (StackPhase = {}));
var currentInstance = null;
var mountedQueueStack = new Map();
var pushMountedQueue = function (uid) {
    callMountedQueue(uid);
    var mountedQueue = [];
    mountedQueueStack.set(uid, mountedQueue);
    return mountedQueue;
};
var callMountedQueue = function (uid) {
    var mountedQueue = mountedQueueStack.get(uid);
    if (!mountedQueue)
        return;
    mountedQueueStack.delete(uid);
    callAll(mountedQueue);
};
var Component = /*#__PURE__*/ /*#__PURE__*/ /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component(props, $vNode, $SVG, $mountedQueue, $parent) {
        var _this = _super.call(this, props, $vNode, $SVG, $mountedQueue, $parent) || this;
        _this.$isVueNext = false;
        var vuePublicInstance = $vNode._vueInstance;
        _this.vueInstance = vuePublicInstance;
        if (vuePublicInstance) {
            // set the instance to the setupState of vueIntance.$
            // ps: setupState is @internal in vue
            vuePublicInstance.setupState.instance = _this;
            _this.$isVueNext = true;
        }
        // disable async component 
        _this.$inited = true;
        return _this;
    }
    Object.defineProperty(Component, "__vccOpts", {
        get: function () {
            var Ctor = this;
            if (Ctor.__cache) {
                return Ctor.__cache;
            }
            return (Ctor.__cache = {
                name: Ctor.displayName || Ctor.name,
                Component: Ctor,
                // Don't inherit attributes, becasue kpc component has do it.
                // https://v3.vuejs.org/guide/component-attrs.html#attribute-inheritance
                inheritAttrs: false,
                setup: function (props, setupContext) {
                    var setupState = { instance: null };
                    var proxy = new Proxy(setupState, {
                        get: function (_a, key) {
                            var instance = _a.instance;
                            if (key === '__v_isReactive')
                                return true;
                            if (instance === null)
                                return null;
                            if (key === 'instance')
                                return instance;
                            var value = instance[key];
                            if (isFunction(value)) {
                                // should bind instance, otherwise the `this` may point to proxyToUse
                                return value.bind(instance);
                            }
                            return value;
                        },
                        set: function (setupState, key, value) {
                            // if (key === 'instance') {
                            return Reflect.set(setupState, key, value);
                            // }
                            // return Reflect.set(setupState.instance!, key, value);
                        },
                        getOwnPropertyDescriptor: function () {
                            return {
                                value: undefined,
                                writable: true,
                                enumerable: true,
                                configurable: true,
                            };
                        },
                        ownKeys: function () {
                            return [];
                        }
                    });
                    return proxy;
                },
                render: function (proxyToUse, renderCache, props, setupState) {
                    var vueInstance = proxyToUse.$;
                    var vNode = normalize(vueInstance.vnode, false);
                    var _setScopeId = function (element) {
                        var vnode = vueInstance.vnode;
                        setScopeId(element, vnode, vnode.scopeId, vnode.slotScopeIds, vueInstance.parent, true);
                    };
                    var mountedQueue = pushMountedQueue(vueInstance.uid);
                    var parentComponent = getIntactParent(vueInstance.parent);
                    var isSVG = parentComponent ? parentComponent.$SVG : false;
                    var subTree = createVNode$1(Comment);
                    if (!vueInstance.isMounted) {
                        // add subTree firstly, because when we mount vue element in intact,
                        // Vue need the property on calling setScopeId
                        vueInstance.subTree = subTree;
                        vNode._vueInstance = vueInstance;
                        mount(vNode, null, parentComponent, isSVG, null, mountedQueue);
                        // hack the nodeOps of Vue to create the real dom instead of a comment
                        var elements_1 = findDomsFromVNode(vNode);
                        if (Ctor.$doubleVNodes) {
                            proxyFragment(elements_1);
                        }
                        var nativeCreateComment_1 = document.createComment;
                        document.createComment = function () {
                            document.createComment = nativeCreateComment_1;
                            if (isFragmentDom(elements_1)) {
                                _setScopeId(elements_1.firstElementChild);
                            }
                            else {
                                _setScopeId(elements_1);
                            }
                            return elements_1;
                        };
                    }
                    else {
                        var instance = setupState.instance;
                        var lastVNode = instance.$vNode;
                        patch$1(lastVNode, vNode, this.$el.parentElement, parentComponent, isSVG, null, mountedQueue, false);
                        // element may have changed 
                        // only check if the component returns only one vNode
                        if (!Ctor.$doubleVNodes) {
                            var element = findDomFromVNode(vNode, true);
                            var oldSubTree = vueInstance.subTree;
                            if (oldSubTree.el !== element) {
                                oldSubTree.el = element;
                                // set scope id
                                _setScopeId(element);
                            }
                        }
                    }
                    return subTree;
                },
                mounted: function () {
                    proxyFragmentParent(this.$el);
                    callMountedQueue(this.$.uid);
                },
                updated: function () {
                    callMountedQueue(this.$.uid);
                },
                beforeUnmount: function () {
                    // we should get property by instance, if the name starts with '$'
                    unmount$1(this.instance.$vNode, null);
                },
            });
        },
        enumerable: false,
        configurable: true
    });
    Component.prototype.$render = function (lastVNode, nextVNode, parentDom, anchor, mountedQueue) {
        var popInstance = pushInstance(this);
        _super.prototype.$render.call(this, lastVNode, nextVNode, parentDom, anchor, mountedQueue);
        popInstance();
    };
    Component.prototype.$update = function (lastVNode, nextVNode, parentDom, anchor, mountedQueue, force) {
        var popInstance = pushInstance(this);
        _super.prototype.$update.call(this, lastVNode, nextVNode, parentDom, anchor, mountedQueue, force);
        popInstance();
    };
    Component.$cid = 'IntactVueNext';
    Component.$doubleVNodes = false;
    Component.__cache = null;
    Component.functionalWrapper = functionalWrapper;
    Component.normalize = normalizeChildren;
    return Component;
}(Component$1));
function createStack() {
    var stack = [];
    function pushStack(item) {
        stack.push(item);
        return item;
    }
    function popStack() {
        return stack.pop();
    }
    return [pushStack, popStack, stack];
}
var _a = createStack(), _pushInstance = _a[0], _popInstance = _a[1];
function pushInstance(instance) {
    var lastIntance = currentInstance;
    currentInstance = _pushInstance(instance);
    return function () {
        _popInstance();
        currentInstance = lastIntance;
    };
}
function getIntactParent(parent) {
    if (currentInstance) {
        return currentInstance;
    }
    // maybe we mount/update a intact component in Vue component
    // let parent: ComponentInternalInstance | null = instance;
    while (parent) {
        var instance = parent.setupState.instance;
        if (instance instanceof Component) {
            return parent.fakeInstance || instance;
        }
        parent = parent.parent;
    }
    return null;
}

export { Component, mountedQueueStack, normalizeChildren as normalize };
